module.exports = __webpack_public_path__ + "static/7-df42b8828902f04f7b2c5f966babe1e1.jpg";